// Field labels for human-readable conflict resolution
export const FIELD_LABELS = {
  equipment: {
    name: 'Name', 
    class: 'Category',
    maintenance: 'Maintenance intervals', 
    standards: 'Standards',
    serialNumber: 'Serial number', 
    location: 'Location', 
    notes: 'Notes',
    lastService: 'Last service (app-managed)', 
    nextService: 'Next service (app-managed)',
    type: 'Equipment type',
    manufacturer: 'Manufacturer',
    model: 'Model',
    specifications: 'Specifications',
    condition: 'Condition',
    status: 'Status'
  },
  procedures: {
    title: 'Title', 
    steps: 'Steps', 
    references: 'References',
    locked: 'Template locked', 
    notes: 'Notes',
    content: 'Content',
    type: 'Document type',
    status: 'Status',
    reviewFrequency: 'Review frequency',
    lastReviewed: 'Last reviewed',
    reviewDue: 'Review due'
  },
  drills: {
    type: 'Drill type', 
    frequency: 'Frequency', 
    participants: 'Participants',
    evidence: 'Evidence', 
    location: 'Location', 
    notes: 'Notes',
    date: 'Date',
    duration: 'Duration',
    outcome: 'Outcome',
    inspector: 'Inspector',
    defects: 'Defects found'
  },
  training: {
    role: 'Role', 
    topic: 'Topic', 
    refresh: 'Refresh interval',
    evidence: 'Evidence', 
    attachments: 'Attachments', 
    notes: 'Notes',
    trainee: 'Trainee',
    trainer: 'Trainer',
    date: 'Date',
    duration: 'Duration',
    competency: 'Competency level',
    certification: 'Certification'
  },
  inspections: {
    what: 'What to inspect', 
    how: 'Checklist / How', 
    frequency: 'Frequency',
    assignedTo: 'Assigned to', 
    lastDone: 'Last done (app-managed)', 
    notes: 'Notes',
    equipmentType: 'Equipment type',
    checkType: 'Check type',
    category: 'Category',
    regulation: 'Regulation',
    interval: 'Interval',
    status: 'Status',
    nextDue: 'Next due'
  },
};